import React from 'react';
import Reveal from './Reveal';
import './Highlights.css';

/**
 * Seção "Em destaque" — logo abaixo do Hero, para que as novidades
 * (novo curta, poesias, vídeos e imprensa) apareçam assim que a pessoa
 * entra no site. Cada card leva para a seção completa correspondente.
 */
const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const featured = {
  tag: 'Novo curta-metragem',
  title: 'Ilha dos Tubarões: O Segredo do Código 4000',
  tagline: 'Quando Tone promete, Tone cumpre.',
  text:
    'Numa prisão de segurança máxima erguida sobre uma ilha de pedra, o detento Tone descobre o segredo que pode libertar todos os presos. Roteiro completo de Antônio Varella, assinado página a página.',
  image: '/poster-ilha.jpg',
  alt: 'Pôster do curta Ilha dos Tubarões: O Segredo do Código 4000',
  pdf: '/ilhadostubaroes.pdf',
  target: 'audiovisual'
};

const cards = [
  {
    id: 'dragao',
    tag: 'Novo roteiro',
    title: 'A Medalha de um Dragão',
    text: 'Iheitokk, o Dragão, luta para recuperar a medalha de ouro que é a honra da sua família.',
    image: '/poster-dragao.jpg',
    alt: 'Pôster do curta A Medalha de um Dragão',
    cta: 'Ver os curtas',
    target: 'audiovisual'
  },
  {
    id: 'poesias',
    tag: 'Poesias',
    title: 'Sentimentos de Varella',
    text: '“Quem é este menino poeta? Este menino poeta sou eu.” Quatro poesias para ler no site ou baixar em PDF.',
    image: '/jornal.jpeg',
    alt: 'Poesias de Varella publicadas em jornal',
    cta: 'Ler as poesias',
    target: 'written-works'
  },
  {
    id: 'videos',
    tag: 'Vídeos & músicas',
    title: 'Sambas em vídeo',
    text: '“Rio de Janeiro Cidade Maravilhosa”, “Barraco de Zinco” e mais — no YouTube e no Palco MP3.',
    image: 'https://i.ytimg.com/vi/tdNHXY0Tc-c/hqdefault.jpg',
    alt: 'Vídeo da música Rio de Janeiro Cidade Maravilhosa',
    cta: 'Assistir',
    target: 'music',
    video: true
  },
  {
    id: 'revista',
    tag: 'Na mídia',
    title: 'Capa da Revista Close Brazil',
    text: '“O novo capítulo de um cantor que nunca desistiu” — ensaio e biografia na edição on-line 2025.',
    image: '/revista-close-capa.jpg',
    alt: 'Varella Sambista na capa da Revista Close Brazil',
    cta: 'Ler a matéria (PDF)',
    href: '/revista-close-brazil-varella.pdf'
  }
];

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M8 5.14v13.72a1 1 0 0 0 1.54.84l10.3-6.86a1 1 0 0 0 0-1.68L9.54 4.3A1 1 0 0 0 8 5.14Z" />
  </svg>
);

const Highlights = () => {
  return (
    <section id="highlights" className="highlights section" aria-labelledby="highlights-title">
      <div className="container">
        <Reveal>
          <span className="section-eyebrow">Novidades</span>
          <h2 id="highlights-title" className="section-title">Em destaque</h2>
          <p className="section-subtitle">
            O novo curta-metragem, as poesias e os vídeos do Varella — tudo reunido
            aqui para você conhecer logo ao entrar.
          </p>
        </Reveal>

        <div className="hl-grid">
          <Reveal as="article" className="hl-featured">
            <div className="hl-featured-media">
              <img src={featured.image} alt={featured.alt} width="600" height="900" />
              <span className="hl-tag hl-tag--new">{featured.tag}</span>
            </div>
            <div className="hl-featured-body">
              <h3 className="hl-featured-title">{featured.title}</h3>
              <p className="hl-featured-tagline">“{featured.tagline}”</p>
              <p className="hl-featured-text">{featured.text}</p>
              <div className="hl-featured-actions">
                <a href={featured.pdf} target="_blank" rel="noopener noreferrer" className="btn">
                  Ler o roteiro
                </a>
                <button className="btn btn-secondary" onClick={() => scrollTo(featured.target)}>
                  Ver todos os curtas
                </button>
              </div>
            </div>
          </Reveal>

          {cards.map((card, index) => {
            const inner = (
              <>
                <div className={`hl-card-media ${card.video ? 'is-video' : ''}`}>
                  <img src={card.image} alt={card.alt} loading="lazy" />
                  <span className="hl-tag">{card.tag}</span>
                  {card.video && <span className="hl-play"><PlayIcon /></span>}
                </div>
                <div className="hl-card-body">
                  <h3 className="hl-card-title">{card.title}</h3>
                  <p className="hl-card-text">{card.text}</p>
                  <span className="hl-card-cta">{card.cta} →</span>
                </div>
              </>
            );

            return card.href ? (
              <Reveal
                as="a"
                key={card.id}
                className="hl-card"
                delay={(index + 1) * 80}
                href={card.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {inner}
              </Reveal>
            ) : (
              <Reveal
                as="button"
                key={card.id}
                className="hl-card"
                delay={(index + 1) * 80}
                type="button"
                onClick={() => scrollTo(card.target)}
              >
                {inner}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
